import React from "react";
import { Col, InputGroup, Row, FormControl } from "react-bootstrap";

const APIKeysView = (props) => {
  return (
    <div>
      <Row>
        <Col sm={12} md={6}>
          <div className="mb-5">
            <h2>Write API Key</h2>
            <div className="my-3">
              <InputGroup className="mb-3 w-75 mx-auto">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-default">
                    Key
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  aria-label="Key"
                  value={props.channelData.write_api_key}
                  readOnly
                  aria-describedby="inputGroup-sizing-default"
                />
              </InputGroup>
            </div>
            <div className="text-center">
              <button className="btn btn-warning" disabled={true}>
                Generate New Write API Key
              </button>
            </div>
          </div>
          {/* <div className="mb-5">
            <h2>Read API Keys</h2>
            <div className="my-3">
              <InputGroup className="mb-3 w-75 mx-auto">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-default">
                    Key
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  aria-label="Key"
                  value="IGUWLXYU9HQ2258Y"
                  readOnly
                  aria-describedby="inputGroup-sizing-default"
                />
              </InputGroup>

              <InputGroup className="mx-auto mb-3 w-75">
                <InputGroup.Prepend>
                  <InputGroup.Text>Note</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  readOnly
                  as="textarea"
                  aria-label="With textarea"
                />
              </InputGroup>
            </div>
            <div className="text-center">
              <button className="btn btn-success mr-3" disabled={true}>
                Save Note
              </button>
              <button className="btn btn-danger" disabled={true}>
                Delete API Key
              </button>
            </div>
          </div> */}
          <hr />

          {/* <div className="text-center">
            <button className="btn btn-warning" disabled={true}>
              Add New Read API Key
            </button>
          </div> */}
        </Col>
        <Col sm={12} md={6}>
          <h2 className="mb-3">Help</h2>
          <p>
            API keys enable you to write data to a channel or read data from a
            private channel. API keys are auto-generated when you create a new
            channel.
          </p>

          <h4>API Keys Settings</h4>
          <ul className="helpUL">
            <li>
              <b>Write API Key:</b>
              Use this key to write data to a channel. If you feel your key has
              been compromised, click Generate New Write API Key.
            </li>
            <li>
              <b>Read API Keys:</b>
              Use this key to allow other people to view your private channel
              feeds and charts. Click Generate New Read API Key to generate an
              additional read key for the channel.
            </li>
            <li>
              <b>Notes:</b>
              Use this field to enter information about channel read keys. For
              example, add notes to keep track of users with access to your
              channel.
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );
};

export default APIKeysView;
